import axiosInstance from '../functions/axiosInstance';
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const revokeInviteLink = async (resourceId = null, inviteCode = null, apiToken = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!resourceId) {
        console.log("no resourceId");
        return null;
    }
    if (!inviteCode) {
        console.log("no inviteCode");
        return null;
    }
    console.log("CALLING SERVER with revokeinvitecodeforresource")
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'revokeinvitecodeforresource',
            'apiToken': apiToken,
            'createinvitelink': true,
            'resourceid': resourceId,
            'invitecode': inviteCode,
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from revokeinvitecodeforresource call");
    }).catch((error) => { console.log(error); });
};

export default revokeInviteLink;